import { nextTick } from 'vue'
import { createWebHistory, createRouter } from 'vue-router'
import PrakerjaRouter from './prakerjaRouter'
import SertifikatRouter from './sertifikatRouter'
// import PortofolioRouter from './portofolioRouter'
import PortofolioRouter from './portofolioV2Router'
import LembagaRouter from './lembagaRouter'
import axios from 'axios'
import store from '../store'
import PaymentRouter from './paymentRouter'
import ReceiptRouter from './receiptRouter'
import docsRouter from './docsRouter'
import faceRecognitionRouter from './faceRecognitionRouter'
import ProgramActivityAPI from '@/api/program-activity'
import { validateActivityAccess, validateRedemptionProgram } from '@/functions/activityValidate'
import appUrl from '@/constants/appUrl.js'
import { showErrorAlert } from '@/functions/showErrorAlert'

const isPrakerja = location.hostname.toLowerCase().includes('prakerja')
const blackListReferral = [
  '/bantuan',
  '/programmu',
  '/tanyamu',
  '/account',
  '/portofolio/profil',
  '/portofolio/portofolio',
  '/portofolio/hasil-karya',
  '/transkrip',
  '/notifikasi',
  '/tukar-voucher',
  '/daftar-transaksi',
  '/mitra-kolaborasi',
  '/profil-kariermu',
  '/dewan-kariermu',
  '/syarat-ketentuan',
  '/kebijakan-privasi',
  '/404'
]

const nonPlatinumSubdomain = ['www', 'prakerja', 'app', 'vue3', 'localhost', 'rewrite', 'prakerjavue3']
const currentSubDomain = location.hostname.toLowerCase().split('.')[0]
const isPlatinum = !nonPlatinumSubdomain.includes(currentSubDomain)

const routes = [
  ...SertifikatRouter,
  ...PrakerjaRouter,
  ...PaymentRouter,
  ...PortofolioRouter,
  ...LembagaRouter,
  ...ReceiptRouter,
  ...docsRouter,
  ...faceRecognitionRouter,
  {
    path: '/',
    name: 'Home',
    meta: {
      title: !isPrakerja
        ? 'Karier.mu - Platform Pelatihan Online No. 1'
        : 'Kartu Prakerja | Karier.mu',
      metaTags: [
        {
          name: 'description',
          content: !isPrakerja
            ? 'Platform kursus dan pelatihan online untuk meningkatkan kemampuan dan keahlian di berbagai bidang. Jalani proses belajar yang mudah, cepat, dan kredibel di Karier.mu'
            : 'Pendaftaran dan Pembelian Kartu Prakerja 2021 Gelombang 12 sampai gelombang 17 di Karier.mu. Jalani proses belajar yang mudah, cepat, dan dapatkan insentif kartu prakerja'
        },
        {
          name: 'keywords',
          content: !isPrakerja
            ? 'pelatihan, kursus online, kelas online, bersertifikat, softskill'
            : 'prakerja, kartu prakerja, insentif kartu prakerja, kariermu,  prakerja kariermu, pelatihan kartu prakerja'
        },
        {
          name: 'robots',
          content: 'index, follow'
        },
        {
          name: 'language',
          content: 'id'
        },
        {
          name: 'revisit-after',
          content: '3 days'
        },
        {
          'http-equiv': 'content-type',
          content: 'text/html; charset=utf-8'
        }
      ],
      isRedirectedToRewrite: true
    },
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/account',
    name: 'profile',
    meta: {
      isLoginNeeded: true
    },
    component: () => import(/* webpacklChunkName: 'profile' */ '../views/ProfileV3.vue'),
    children: [
      {
        path: 'personal',
        name: 'personal',
        meta: {
          isLoginNeeded: true
        },
        component: () => import(/* webpacklChunkName: 'personal-data' */ '../components/profile/PersonalData.vue')
      },
      {
        path: 'institution',
        name: 'institution',
        meta: {
          isLoginNeeded: true
        },
        component: () => import(/* webpacklChunkName: 'institution-data' */ '../components/profile/InstitutionData.vue')
      },
      {
        path: 'privacy',
        name: 'privacy',
        meta: {
          isLoginNeeded: true
        },
        component: () => import(/* webpacklChunkName: 'privacy-setting' */ '../components/profile/PrivacySettings.vue')
      },
      {
        path: 'password',
        name: 'password',
        meta: {
          isLoginNeeded: true
        },
        component: () => import(/* webpacklChunkName: 'lock-password' */ '../components/profile/PasswordSetting.vue')
      },
      ...!isPrakerja ? [{
        path: 'pin',
        name: 'pin',
        meta: {
          isLoginNeeded: true
        },
        component: () => import(/* webpacklChunkName: 'lock-pin' */ '../components/profile/PinData.vue')
      }] : []
    ]
  },
  {
    path: '/forgot-password',
    name: 'Reset Password',
    meta: {
      layout: 'reset-password',
      title: 'Reset Password | Karier.mu'
    },
    component: () => import(/* webpacklChunkName: 'reset-password-v2' */ '../views/ResetPasswordV2.vue'),
    beforeEnter (to, from, next) {
      if (window.$cookies.get('access-token')) {
        setTimeout(() => {
          window.open(store.state.kariermuRewriteUrl, '_self')
        }, 5000)
      } else {
        next()
      }
    }
  },
  {
    path: '/setup-password',
    name: 'Setup Password',
    meta: {
      layout: 'reset-password',
      title: 'Setup Password | Karier.mu'
    },
    component: () => import(/* webpacklChunkName: 'setup-password' */ '../views/ResetPasswordV2.vue'),
    beforeEnter (to, from, next) {
      if (window.$cookies.get('access-token')) {
        setTimeout(() => {
          window.open(store.state.kariermuRewriteUrl, '_self')
        }, 5000)
      } else {
        next()
      }
    }
  },
  {
    path: '/tanyamu',
    name: 'tanyamu',
    props: true,
    meta: {
      layout: 'no-footer',
      title: 'Diskusi Tanya Jawab Program | Karier.mu'
    },
    component: () => import(/* webpacklChunkName: 'tanyamu' */ '../views/tanyamu/Tanyamu.vue')
  },
  {
    path: '/aktivitas/:id',
    name: 'activity-program',
    meta: {
      layout: 'activity-v2',
      isLoginNeeded: true
    },
    component: () => import('../views/ActivityV2FlowRedeem.vue'),
    async beforeEnter (to, from, next) {
      await nextTick(async function () {
        const apiResult = await ProgramActivityAPI.validateActivity({
          data: {
            type_access: 'activity',
            user_id: store.state.storage.userId,
            slug: to.params.id
          },
          Authorization: store.state.storage.accessToken
        })
        if (apiResult.data.status === 400) {
          // Handle Error Prakerja 2024, agar user aware kenapa program tidak dapat dibuka.
          // Contoh case: Error redeem code sudah digunakan.
          // Error message yang ditampilkan merupakan response langsung dari service Prakerja.
          showErrorAlert(
            apiResult?.data,
            null,
            apiResult?.message || apiResult?.data?.message || '',
            'ERRV2PRAC'
          )
          return false
        }
        const apiData = apiResult.data.data ? apiResult.data.data : apiResult.data
        const validateResult = validateActivityAccess(apiData)
        const isRedemptionProgramValid = validateRedemptionProgram(apiData)

        if (apiData.platform === 'sekolahmu') {
          window.open(`${appUrl.sekolahmuUrl()}/aktivitas/${apiData.activity_slug}`, '_self')
          next(false)
        } else if (validateResult.toNotFound) {
          next('/404')
        } else if (validateResult.toProgramDetail) {
          next(`/program/${apiData.program_slug}`)
        } else if (validateResult.toKelasku) {
          next('/kelasku')
        } else {
          if (!isRedemptionProgramValid) {
            store.commit('activityV2/TOGGLE_REDEEM_CODE_MODAL', true)
          }
          store.commit('activityV2/SET_ACTIVITY_VALIDATE', apiData)
          next()
        }
      })
    }
  },
  {
    path: '/verification',
    name: 'verification',
    component: () => import('../views/Verification.vue')
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/report/ProgramReport.vue')
  },
  {
    path: '/transkrip',
    name: 'Transkrip',
    meta: {
      title: 'Transkrip',
      metaTags: [
        {
          name: 'title',
          content: 'Transkrip | Karier.mu'
        }
      ]
    },
    component: () => import('../views/programmu/Transcript.vue')
  },
  {
    path: '/kilas-balik-2021',
    name: 'Kilas Balik 2021',
    meta: {
      title: 'Kilas Balik 2021 | Karier.mu',
      metaTags: [
        {
          name: 'description',
          content: 'Tahun yang berkesan bersama Karier.mu di 2021. Di kilas balik, Anda bisa melihat perkembangan dan dampak yang dihasilkan Karier.mu sebagai partner profesional untuk wujudkan karier impian.'
        }
      ]
    },
    component: () => import(/* webpackChunkName: 'general-report' */ '../views/flashbackKariermu/GeneralReport.vue')
  },
  {
    path: '/redirect-fun-report',
    name: 'Fen Report Deeplink',
    meta: {
      layout: 'blank'
    },
    component: () => import(/* webpackChunkName: 'general-report' */ '../views/flashbackKariermu/AppsDeeplinkRedirectionPage.vue')
  },
  {
    path: '/addon',
    name: 'Addon',
    component: () => import('../views/report/AddonReport.vue')
  },
  {
    path: '/programmu',
    name: 'Programmu',
    meta: {
      title: 'Daftar Programmu',
      metaTags: [
        {
          name: 'title',
          content: 'Daftar Programmu | Karier.mu'
        }
      ]
    },
    component: () => import(/* webpackChunkName: 'list-programu' */ '../views/programmu/Programmu.vue')
  },
  {
    path: '/notifikasi',
    name: 'Notifikasi',
    component: () => import(/* webpackChunkName: 'notifikasi' */ '../views/notification/NotificationV2.vue')
  },
  // temporary route for revamp program detail
  {
    path: '/pengumuman/:slug',
    name: 'Pengumuman',
    component: () => import(/* webpackChunkName: 'pengumuman' */ '../views/announcement/AnnouncementDetail.vue')
  },
  // temporary route for revamp program detail
  {
    path: '/program/:id',
    name: 'ProgramDetail',
    meta: {
      isRedirectedToRewrite: true
    }
  },
  {
    path: '/review/:id',
    name: 'ReviewProgram',
    component: () => import('../views/program/ReviewProgram.vue'),
    beforeEnter (to, from, next) {
      if (from.name === 'activity-program') {
        localStorage.setItem('prev-route', from.params.id)
      }
      next()
    }
  },
  {
    path: '/katalog-poin',
    name: 'katalog poin',
    meta: {
      isRedirectedToRewrite: true
    }
  },
  {
    path: '/program',
    name: 'Program',
    component: () => import(/* webpackChunkName: 'list-program' */ '../views/programmu/ListProgramV2.vue'),
    meta: {
      title: 'Hasil Pencarian Program | Karier.mu',
      isRedirectedToRewrite: true
    }
  },
  {
    path: '/pencarian',
    name: 'Pencarian',
    component: () => import(/* webpackChunkName: 'list-program' */ '../views/programmu/ListProgram.vue')
  },
  {
    path: '/jenjang/:level/:year',
    name: 'program-by-year-level',
    component: () => import(/* webpackChunkName: 'list-program' */ '../views/program/ProgramByYearLevel.vue')
  },
  {
    path: '/jenjang/:level',
    name: 'program-by-level',
    component: () => import(/* webpackChunkName: 'list-program' */ '../views/program/ProgramByYearLevelV2.vue')
  },
  {
    path: '/program-pilihan',
    name: 'Semua-Program-Pilihan',
    component: () => import(/* webpackChunkName: 'all-program' */ '../views/program/AllProgramPilihan.vue'),
    meta: {
      isRedirectedToRewrite: true
    }
  },
  {
    path: '/program-pilihan/:slug',
    name: 'Program-Pilihan',
    component: () => import(/* webpackChunkName: 'list-program' */ '../views/program/ProgramPilihan.vue'),
    meta: {
      isRedirectedToRewrite: true
    }
  },
  {
    path: '/ikutprogram',
    name: 'Ikut Program',
    meta: {
      title: 'Ikut Program'
    },
    component: () => import(/* webpackChunkName: 'ikut-program' */ '../views/IkutProgram.vue'),
    beforeEnter: (to, from, next) => {
      next('/program')
    }
  },
  {
    path: '/panduan-prakerja',
    name: 'panduan-prakerja',
    component: () => import('../views/PanduanPrakerja.vue')
  },
  {
    path: '/zoom-meeting/android/:roomId/:password/:role/:name/:apiKey',
    name: 'zoom-meeting-android',
    component: () => import('../views/ZoomMeetingAndroid.vue'),
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/zoom-meeting/:roomId/:password/:role/:name/:apiKey',
    name: 'zoom-meeting',
    component: () => import('../views/ZoomMeeting.vue'),
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/zoom-leave/',
    name: 'zoom-leave',
    component: () => import('../views/ZoomLeavePage.vue'),
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/404',
    name: 'not-found-error',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: '404 | Karier.mu',
      metaTags: [
        {
          name: 'robots',
          content: 'noindex'
        }
      ]
    }
  },
  {
    path: '/:title',
    name: 'redirect',
    component: () => import('../views/Redirect.vue'),
    beforeEnter: async (to, from, next) => {
      if (to.path === '/kariermu') {
        next('/ikutprogram?id=kariermu')
      } else if (to.path === '/kelasmu') {
        next('/ikutprogram?id=kelasmu')
      } else if (to.path === '/ujianmu') {
        next('/ikutprogram?id=ujianmu')
      } else if (to.path === '/prakerja') {
        next('/ikutprogram?id=prakerja')
      } else {
        try {
          const { data } = await axios.get('https://cdn.karier.mu/config/kariermu/web/landing-page-mitra/data-landing-page.json')
          const availableProjects = data.filter(project => project.route === to.path)
          if (availableProjects.length && to.path !== from.path) {
            next({
              name: 'landing-page-project',
              params: {
                project: availableProjects[0].route.slice(1),
                ...availableProjects[0]
              },
              query: to.query
            })
          } else {
            next('/404')
          }
        } catch (error) {
          next('/404')
        }
      }
    }
  },
  {
    path: '/:project',
    name: 'landing-page-project',
    component: () => import('../views/project/CustomizableProject.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue'),
    beforeEnter: (to, form, next) => {
      next('/404')
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.isRedirectedToRewrite && !isPlatinum) {
    // kalo localhost, jangan redirect
    window.open(`${store.state.kariermuRewriteUrl}${to.fullPath}`, '_self')
  } else {
    // temporarily commented

    // document.querySelector("[rel='canonical']").remove()
    // const link = document.createElement('link')
    // link.rel = 'canonical'

    // let sub_domain = window.location.hostname.includes('prakerja') ? 'prakerja' : 'www'
    // link.href = `https://${sub_domain}.sekolah.mu${to.path}`
    // document.head.appendChild(link)
    if (to.path !== '/404' && document.querySelector("[content='noindex']")) {
      document.querySelector("[content='noindex']").remove()
    }

    if (to.query && to.query.verification && to.path !== '/forgot-password') {
      store.commit('SET_VERIFICATION', to.query)
    }

    // check if page need to login before access
    if (to.meta.isLoginNeeded && !window.$cookies.get('access-token')) {
      next({ path: '/', query: { 'redirect-path': to.path, 'redirect-name': to.name } })
    }

    if (to.meta.title) {
      document.title = `${to.meta.title} - Karier.mu`
    } else {
      document.title = 'Karier.mu'
    }

    // handle redirection for reset PIN
    if (to.path === '/forgot-pin-payment' && 'pkey' in to.query) {
      store.commit('SET_PIN_PKEY', to.query.pkey)
      next('/account/pin?type=new&field=pin')
    }

    // remove meta
    if (from.meta.metaTags) {
      from.meta.metaTags.forEach(tag => {
        for (const property in tag) {
          if (property === 'content') {
            const meta = document.querySelectorAll(`[${property}='${tag[property]}']`)
            if (meta.length > 0) {
              meta[meta.length - 1].remove()
            }
          }
        }
      })
    }

    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title

    // Remove any stale meta tags from the document using the key attribute we set below.
    // Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) {
      // DEFINE REFERAL
      if (from.query.ref && !to.query.ref && !blackListReferral.includes(to.path) && (from.path !== '/checkout')) {
        const path = to.path
        const query = to.query
        query.ref = from.query.ref
        return next({ path, query })
      }
      return next()
    }
    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      // tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
      // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag))

    // DEFINE REFERAL
    if (from.query.ref && !to.query.ref && !blackListReferral.includes(to.path) && (from.path !== '/checkout')) {
      const path = to.path
      const query = to.query
      query.ref = from.query.ref
      next({ path, query })
    }
    next()
  }
})

export default router
